<template>
  <div class="video-background-component">
    <youtube-video v-if="isYoutube" :url="url" />
    <vimeo-video v-else-if="isVimeo" :url="url" />
    <video-player
      v-else-if="isPanda"
      is-background
      :lesson="{ link_media: url }"
    />
  </div>
</template>
<script>
import YoutubeVideo from "@/components/preview/YoutubeVideo.vue";
import VimeoVideo from "@/components/preview/VimeoVideo.vue";
import VideoPlayer from "@/components/lesson/VideoPlayer";
export default {
  components: { YoutubeVideo, VimeoVideo, VideoPlayer },
  props: ["url"],
  computed: {
    isVimeo() {
      return this.url.includes("vimeo");
    },
    isYoutube() {
      return this.url.includes("youtu");
    },
    isPanda() {
      return this.url.includes("pandavideo");
    }
  }
};
</script>
<style lang="scss" scoped>
.video-background-container {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
</style>
